import { AuthId } from "@common/constans";
import { ICancelRequest } from "@common/models/CancelRequest";
import { IModificationPricingInfo } from "@common/models/ModificationPricingInfo";
import { IPnrInfo } from "@common/models/PnrInfo";
import { IResponse } from "@common/models/Response";
import Api, { IOptions } from "@service/Api";
import { Action } from "./Proxy";

export function segmentCancellationConfirmation<T = ICancelRequest, U = IPnrInfo>(action: Action, options?: IOptions<T>): Promise<IResponse<U>> {
    switch (action) {
        case Action.POST:
            return Api.post<T, U>("Cancelation/Segment/Confirm", {
                ...options,
                raiseError: options?.raiseError ?? true,
                authenticationId: options?.authenticationId ?? AuthId.ManageBooking,
                callBackTrigger: options?.callBackTrigger ?? true
            });
    }
    return Promise.reject();
}

export function reserveCancellationConfirmation<T = ICancelRequest, U = IPnrInfo>(action: Action, options?: IOptions<T>): Promise<IResponse<U>> {
    switch (action) {
        case Action.POST:
            return Api.post<T, U>("Cancelation/Reserve/Confirm", {
                ...options,
                raiseError: options?.raiseError ?? true,
                authenticationId: options?.authenticationId ?? AuthId.ManageBooking,
                callBackTrigger: options?.callBackTrigger ?? true
            });
    }
    return Promise.reject();
}

export function reserveCancellationQuery<T = ICancelRequest, U = IModificationPricingInfo>(action: Action, options?: IOptions<T>): Promise<IResponse<U>> {
    switch (action) {
        case Action.POST:
            return Api.post<T, U>("Cancelation/Reserve/Query", {
                ...options,
                raiseError: options?.raiseError ?? false,
                authenticationId: options?.authenticationId ?? AuthId.ManageBooking,
                callBackTrigger: options?.callBackTrigger ?? true
            });
    }
    return Promise.reject();
}

export function segmentCancellationQuery<T = ICancelRequest, U = IModificationPricingInfo>(action: Action, options?: IOptions<T>): Promise<IResponse<U>> {
    switch (action) {
        case Action.POST:
            return Api.post<T, U>("Cancelation/Segment/Query", {
                ...options,
                raiseError: options?.raiseError ?? false,
                authenticationId: options?.authenticationId ?? AuthId.ManageBooking,
                callBackTrigger: options?.callBackTrigger ?? true
            });
    }
    return Promise.reject();
}